import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { useNews } from "@/hooks/useData";
import { imgUrl } from "@/lib/api";

export default function News() {
  const { data: news = [], isLoading } = useNews();
  return (
    <div data-testid="news-page">
      <PageHeader eyebrow="Newsroom" title="Stories from the" accent="atelier." description="Insights, trends and behind-the-scenes looks at how we source, inspect and deliver." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-20">
        {isLoading ? (
          <p className="text-[#5E5A54] font-light">Loading…</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {news.map((n, i) => (
              <Reveal key={n.id} delay={(i % 3) * 0.07}>
                <article className="group" data-testid={`news-${n.id}`}>
                  <div className="img-frame aspect-[4/3] bg-[#F6F5F2]">
                    <img src={imgUrl(n.image_url)} alt={n.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <p className="label-eyebrow text-[10px] text-[#9E8773] mt-5">{n.category} · {n.date}</p>
                  <h3 className="font-display text-2xl font-medium text-[#2C2A29] mt-2 group-hover:text-[#9E8773] transition-colors">{n.title}</h3>
                  <p className="text-[#5E5A54] font-light leading-relaxed mt-2">{n.excerpt}</p>
                </article>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
